import {
  Avatar,
  Skeleton,
} from '@Infowijs-eng/component-library/components'
import { cn } from '@Infowijs-eng/component-library/modules'
import ListItem from '../ListItem'

function AdministratorListSkeleton({ className }) {
  return (
    <div>
      <ListItem className={cn('animate-skeleton-1', className)} leadingAddon={<Avatar />}>
        <div className="w-full space-y-2">
          <Skeleton className="animate-none block w-64" />
          <Skeleton className="animate-none block w-48" />
        </div>
      </ListItem>
      <ListItem className={cn('animate-skeleton-2', className)} leadingAddon={<Avatar />}>
        <div className="w-full space-y-2">
          <Skeleton className="animate-none block w-64" />
          <Skeleton className="animate-none block w-48" />
        </div>
      </ListItem>
      <ListItem className={cn('animate-skeleton-3', className)} leadingAddon={<Avatar />}>
        <div className="w-full space-y-2">
          <Skeleton className="animate-none block w-64" />
          <Skeleton className="animate-none block w-48" />
        </div>
      </ListItem>
    </div>
  )
}

AdministratorListSkeleton.propTypes = {
  className: cn.propType,
}

AdministratorListSkeleton.defaultProps = {
  className: null,
}

export default AdministratorListSkeleton
